import styled from 'styled-components'
import { DefaultFontStyle } from '../../styles/global-styles'

export const ReportPageContainer = styled.div`
  width: 100vw;
  padding: 10px 20px;
  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    padding: 0px 50px;
  }
`

export const PageTitle = styled.h1`
  ${DefaultFontStyle};
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #0b0a0a;
  margin-block-start: 0px;
  @media (min-width: ${props => props.theme.breakpoints.lg}px) {
    font-size: 34px;
  }
`

export const DataContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: 44px 40px 25px;
  gap: 25px 37px;
  @media (max-width: ${props => props.theme.breakpoints.xl}px) {
    gap: 22px 25px;
  }
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    gap: 20px 12px;
    margin: 32px 40px 38px;
  }
  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin: 25px 15px;
    gap: 15px;
  }
`
